import React from "react";
import { FormThemeProvider ,TextField } from "react-md";

export default class FrmForgotPass extends React.Component {
  render() {
    return (
      <div className="ARC_Lgn_dv">
        <FormThemeProvider theme={"underline"}>
          <TextField
            id="IdUsuario"
            label="Correo electrónico"
            lineDirection="center"
            className="lg-cell lg-cell--bottom"
          />
        </FormThemeProvider>
        <label className="lbl_txt">
          Envíar correo de verificación de contraseña
        </label>
      </div>
    );
  }
}
